<template>
  <div class="slider-setting" v-dragWhole>
    <div class="slider-content" v-for="item, i in list">
      <div class="slider-before">{{item.name}}</div>
      <div class="rc-slider">
        <div class="rc-slider-rail"></div>
        <div class="rc-slider-track" :style="{'width': (item.val - item.min)/item.len*100 + '%'}"></div>
        <div :data-action="item.type+'-'+i" class="rc-slider-handle" :style="{'left': (item.val - item.min)/item.len*100 + '%'}"></div>
      </div>
      <div class="slider-after">
        <input type="number"
          v-model="item.val"
          @focus="inputFocus(item, i)"
          @blur="inputBlur"
          @keydown.stop
          @mousedown.stop
          :style="{width: item.unit ? '70%' : '100%'}"
        >
        <div v-show="item.unit">{{item.unit}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      index: 0,
      item: null,
      action: '',
      dragHand: false,
      mpos: null,
      check: false,
    }
  },
  watch: {
    'item.val': function() {
      if(this.check) {
        let val = Math.round(this.item.val / this.item.step) / (1 / this.item.step);
        this.item.val = val > this.item.max ? this.item.max : val < this.item.min ? this.item.min : val;
        this.$emit('changeData', this.item.val, 'change', this.index, this.item);
      }
    }
  },
  methods: {
    dragDown(dis, action) {
      if(!action) return;
      let actionS = action.split('-');
      this.action = actionS[0];
      this.index = +actionS[1];
      this.item = this.list[this.index];
      this.dragHand = true;
      this.mpos = {
        x: dis.x,
        v: this.item.val
      }
      this.$emit('changeData', this.item.val, 'start', this.index, this.item);
    },
    dragMove(pos, action) {
      if(!this.action) return;
      let pre = Math.round(((pos.x - this.mpos.x) / 120 * this.item.len + this.mpos.v) / this.item.step) / (1 / this.item.step);
      this.item.val = pre > this.item.max ? this.item.max : pre < this.item.min ? this.item.min : pre;
      this.$emit('changeData', this.item.val, 'change', this.index, this.item);
    },
    dragUp(pos, action) {
      if(!this.action) return;
      this.mpos = null;
      this.dragHand = false;
      this.action = '';
      this.$emit('changeData', this.item.val, 'end', this.index, this.item);
    },
    inputFocus(item, i) {
      this.item = item;
      this.index = i;
      this.check = true;
      this.$emit('changeData', this.item.val, 'start', this.index, this.item);
    },
    inputBlur() {
      this.check = false;
      this.$emit('changeData', this.item.val, 'end', this.index, this.item);
    }
  }
}
</script>

<style lang="scss" scoped>
.slider-setting {
  width: 100%;
}
.slider-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0px;
  }
  
  .slider-before {
    width: 45px;
    text-align: left;
  }
  .slider-after {
    width: 42px;
    display: flex;
    justify-content: space-between;
    border: 1px solid #D9DDEA;
    border-radius: 4px;
    height: 25px;
    overflow: hidden;

    input {
      width: 70%;
      color: #474261;
      text-align: center;
      border: none;
    }

    div {
      width: 40%;
      text-align: left;
      line-height: 23px;
    }
  }
}
.rc-slider {
  position: relative;
  height: 15px;
  padding: 5px 0;
  width: 120px;
  margin-right: 1px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #D9DDEA;
    height: 4px;
    border-radius: 3px;
  }

  .rc-slider-track {
    position: absolute;
    background-color: #737596;
    border-radius: 3px;
    height: 4px;
    left: 0%;
    width: 69.1515%;
  }

  .rc-slider-handle {
    position: absolute;
    margin-left: -6px;
    margin-top: -4px;
    left: 69.1515%;
    width: 12px;
    height: 12px;
    background-color: #737596;
    cursor: -webkit-grab;
    cursor: grab;
    border-radius: 50%;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settingPanel/sliderSetting.vue